import React from "react";
import PropTypes from "prop-types";

import { reachGoal } from "../utils";

function Result(props) {
  const { points } = props;

  let titleText = <></>;

  if (points <= 3) {
    reachGoal("r_1");

    titleText = (
      <h1 className="result__title">
        <span>0 - 3</span>
        Кажется, вы почти ничего не знаете об NFT. <br />И вот как можно
        восполнить этот пробел.
      </h1>
    );
  }

  if (points >= 4 && points <= 6) {
    reachGoal("r_2");

    titleText = (
      <h1 className="result__title">
        <span>4 - 6</span>
        Вы точно следите за самыми <br />
        громкими продажами криптоарта. <br />
        Но видели ли вы, как его крадут прямо из метавселенной?
      </h1>
    );
  }

  if (points >= 7) {
    reachGoal("r_3");

    titleText = (
      <h1 className="result__title">
        <span>7 - 9</span>
        У вас острый глаз! <br />
        Может, у вас свой аукцион? <br />А мы знаем, чем вам точно будет
        интересно заняться!
      </h1>
    );
  }

  return (
    <>
      {titleText}

      <p className="result__text">
        18 и 19 мая в Москве пройдет{" "}
        <a
          onClick={() => {
            reachGoal("phd_2");
            return true;
          }}
          href="https://phdays.com/ru/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft"
          target="_blank"
        >
          Positive Hack Days
        </a>{" "}
        — международный форум от{" "}
        <a
          onClick={() => {
            reachGoal("pd");
            return true;
          }}
          href="https://www.ptsecurity.com/ru-ru/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft"
          target="_blank"
        >
          Positive Technologies
        </a>
        , посвященный информационной безопасности, с десятками докладов,
        дискуссий и мастер-классов с участием представителей госсектора и
        крупных компаний.
      </p>

      <span className="result__subtitle">Positive Hack Days — это:</span>

      <ul className="result__list">
        <li>
          <span>
            Масштабная открытая кибербитва{" "}
            <a
              onClick={() => {
                reachGoal("standoff_2");
                return true;
              }}
              href="https://standoff365.com/?utm_source=afisha-landing&utm_medium=link&utm_campaign=phd-11-nft"
              target="_blank"
            >
              The Standoff
            </a>
            :
          </span>{" "}
          160 белых хакеров испытают защищенность виртуальных компаний из разных
          отраслей экономики виртуального государства F.
        </li>
        <li>
          <span>Расширенная бизнес-программа:</span> круглые столы и заседания,
          посвященные актуальным проблемам бизнеса с участием госсектора и
          крупных компаний.
        </li>
        <li>
          <span>Технические треки по направлениям:</span> безопасность бытовой и
          промышленный интернет вещей, телекоммуникационные сети, приложения,
          финансовые технологии и инструменты.
        </li>
        <li>
          <span>Хакерские конкурсы:</span> начинающие специалисты попробуют
          взломать банкомат, справиться с багами умного дома и обмануть систему
          биометрической аутентификации.
        </li>
      </ul>

      <p className="result__text">
        На одном из таких конкурсов белые хакеры попытаются похитить несколько
        произведений криптоарта российских художников из виртуальной арт-галереи
        метавселенной Arcona XR Metaverse.
      </p>

      <span className="result__subtitle">
        Хотите увидеть все сами?{" "}
        <a
          onClick={() => {
            reachGoal("podkl");
            return true;
          }}
          href="https://event.phdays.com/ru?utm_source=afisha&utm_medium=article&utm_campaign=promo"
          target="_blank"
          className="result__subtitle"
        >
          Подключайтесь
        </a>{" "}
        к PHDays 2022!
      </span>

      <a
        onClick={() => {
          reachGoal("podkl");
          return true;
        }}
        href="https://event.phdays.com/ru?utm_source=afisha&utm_medium=article&utm_campaign=promo"
        target="_blank"
        className="button result__button"
      >
        Подробнее
      </a>
    </>
  );
}

Result.propTypes = {
  points: PropTypes.number.isRequired,
};

export default Result;
